/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';

const reactProps = {
	children: 1,
	key: 1,
	ref: 1,
};

export const BiContext = createContext({});

export default class ContextProvider extends Component {
	static propTypes = {
		children: PropTypes.node,
	};

	render() {
		const prunedProps = {};
		Object.keys(this.props).forEach(key => {
			if (!reactProps[key]) {
				prunedProps[key] = this.props[key];
			}
		});

		return (
			<BiContext.Consumer>
				{biContext => (
					<BiContext.Provider value={{ ...biContext, ...prunedProps }}>
						{this.props.children}
					</BiContext.Provider>
				)}
			</BiContext.Consumer>
		);
	}
}
